import React, { useEffect } from 'react';
import cN from 'classnames';
import { useMediaQuery } from 'react-responsive';
import { I_Marketing } from '@Redux/detail/Itineraries/interfaces';
import styles from './style.module.scss';

interface I_Props {
    MarketingContent: I_Marketing;
}

const ItineraryMarketing: React.FC<I_Props> = ({ MarketingContent }) => {
    const isPC = useMediaQuery({ query: '(min-width: 980px)' });
    return (
        <div className={styles.itinerary_marketing} id="marketing">
            <a href={MarketingContent?.Url} target="_blank" rel="noreferrer noopener">
                {isPC ? (
                    <img src={MarketingContent?.ImgPC} alt="pc" loading="lazy" />
                ) : (
                    <img src={MarketingContent?.ImgM} alt="M" loading="lazy" />
                )}
            </a>
            <div className={styles.description}>{MarketingContent?.Content}</div>
        </div>
    );
};

export default ItineraryMarketing;
